/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-06-25T18:30:18.948
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentViewOrderRetreat,
	listRentViewOrderRetreatInit,
	listRentViewOrderRetreatByAuthorizations,
	deleteRentViewOrderRetreat
	
} from '@api/rentmanage/RentViewOrderRetreat';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentViewOrderRetreat({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentViewOrderRetreat(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentViewOrderRetreatByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentViewOrderRetreatByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentViewOrderRetreatInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentViewOrderRetreatInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentViewOrderRetreat({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentViewOrderRetreat({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
